// extracted by mini-css-extract-plugin
export default {"wrapper":"CoachDashboardActivity_wrapper__gcFOn","left":"CoachDashboardActivity_left__QxgaK","right":"CoachDashboardActivity_right__HpLr7"};